<div class="c-navbar">
  <div class="left" style="display: inline-grid">
    <span
      class="default-title"
      style="font-size: 14px; color: var(--black-light)"
      >{{ $t("componentPage") }} {{ getPageBreadcrumb($i18n.locale,
      $store?.state?.menus, $route) ? ` / ${getPageBreadcrumb($i18n.locale,
      $store?.state?.menus, $route)}` : `` }}
    </span>
    <span class="default-title">
      {{ $t(getPageTitle($store?.state?.pageTitle)) }}
    </span>
  </div>
  <div class="right">
    <!-- <div>
      <button @click="changeRootFontFamily('lato', 'kohsantepheap', 'sans-serif')" class="btn btn-primary mr10">
        Kohsantepheap
      </button>
      <button @click="changeRootFontFamily('lato', 'noto-sans', 'sans-serif')" class="btn btn-primary mr10">
        Noto Sans
      </button>
    </div> -->
    <span class="mr15">{{ $t("componentVersion") }} : {{ version }}</span>
    <div class="localize">
      <img
        v-if="$helper?.i18nLocale?.value === 'en'"
        @click.stop="$changeLocalize('km')"
        :src="require('@/assets/icons/flags/en.svg')"
        alt=""
      />
      <img
        v-if="$helper?.i18nLocale?.value === 'km'"
        @click.stop="$changeLocalize('en')"
        :src="require('@/assets/icons/flags/km.svg')"
        alt=""
      />
    </div>

    <div class="profile">
      <div class="profile-image">
        <img
          :src="$store?.state?.profile?.imageKey ? $helper?.getFullImage($store?.state?.profile?.imageKey) : require('@/assets/images/user-default.png')"
          alt=""
        />
      </div>
      <div
        @click="isDropdown=!isDropdown"
        v-outside="onClose"
        class="profile-title"
      >
        <div v-if="isDropdown" class="dropdown">
          <ul>
            <li>
              <router-link
                :to="`/setting/user-account/detail/${$store?.state?.profile?.id}`"
              >
                <img src="@/assets/icons/sidebars/profile.svg" />
                <div>{{$t('componentMyAccount')}}</div>
              </router-link>
            </li>
            <li>
              <router-link
                :to="`/setting/user-account/update/${$store?.state?.profile?.id}`"
              >
                <img src="@/assets/icons/sidebars/lock-password.svg" />
                <div>{{$t('componentChangePassword')}}</div>
              </router-link>
            </li>
            <li @click="isLogout=true">
              <img src="@/assets/icons/sidebars/sign-out.svg" />
              <div>{{$t('componentSignOut')}}</div>
            </li>
          </ul>
        </div>
        <div>
          <span class="name mr8"
            >{{ $store?.state?.profile?.fullName &&
            $store?.state?.profile?.fullName }}</span
          >
          <img
            :class="{'down-svg':isDropdown}"
            src="@/assets/icons/sidebars/down.svg"
          />
        </div>
        <span class="desc"
          >{{ $store?.state?.profile?.roles &&
          $store?.state?.profile?.roles[0]?.title }}</span
        >
      </div>
    </div>
  </div>

  <c-modal
    @onClose="cancelLogout"
    @onConfirm="onLogout"
    labelText="componentSignOut"
    :active="isLogout"
  />
</div>
